import { useState } from 'react';
import SEO from '../components/SEO';
import PageLayout from '../components/PageLayout';
import { FAQS, WHATSAPP_LINK } from '../lib/site';

const FaqPage = () => {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <PageLayout
      label="Centro de ayuda"
      title="Preguntas frecuentes"
      titleEm="sobre reformas"
      lead="Todo lo que necesitas saber antes de empezar una obra en Málaga: precios, plazos, permisos y garantías. Sin rodeos."
      crumbs={[{ name: 'FAQ' }]}
    >
      <SEO
        title="Preguntas Frecuentes — Precios y Plazos de Reformas en Málaga"
        description="¿Cuánto cuesta una reforma en Málaga? ¿Cuánto dura? ¿Quién pide los permisos? Respondemos las 8 preguntas más frecuentes sobre reformas y construcción."
        url="/faq"
        breadcrumbs={[{ name: 'Inicio', url: '/' }, { name: 'FAQ', url: '/faq' }]}
        faqSchema={FAQS}
      />

      <section className="max-w-[1400px] mx-auto px-6 py-16 md:py-24">
        <div className="grid lg:grid-cols-[1fr_1.4fr] gap-14 lg:gap-20">
          <div className="reveal lg:sticky lg:top-28 self-start">
            <h2 className="font-display font-black uppercase tracking-tight text-2xl md:text-3xl">
              ¿Tienes otra duda?
            </h2>
            <p className="mt-4 text-ink-soft leading-relaxed">
              Escríbenos por WhatsApp y te respondemos en menos de una hora
              dentro del horario laboral. Sin bots, sin respuestas automáticas.
            </p>
            <a
              href={WHATSAPP_LINK('Hola, tengo una duda sobre mi proyecto de reforma.')}
              target="_blank"
              rel="noopener noreferrer"
              className="btn mt-7 bg-clay text-white"
            >
              Preguntar por WhatsApp
            </a>
          </div>

          <div className="reveal">
            {FAQS.map((f, i) => (
              <div key={i} className="faq-item" data-open={open === i}>
                <button
                  className="faq-question"
                  onClick={() => setOpen(open === i ? null : i)}
                  aria-expanded={open === i}
                >
                  <span>{f.q}</span>
                  <span className="faq-icon" aria-hidden="true">+</span>
                </button>
                <div className="faq-answer">
                  <div className="faq-answer-inner">
                    <p>{f.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default FaqPage;
